export default "__VITE_ASSET__r982sXah__"